/* =============================================
   SCORPIUS UPGRADES
   - Device comparison (localStorage)
   - Quick view modal (Shopify product.js)
   - Trade-in widget on PDPs
   - Free shipping progress bar
   - Cart sustainability counter
   ============================================= */
(function(){
  'use strict';

  /* ---------- helpers ---------- */
  function $(sel, root){ return (root || document).querySelector(sel); }
  function $$(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(p){ return '£' + (Math.round(p) / 100).toFixed(2); }
  function read(key, fb){ try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fb; } catch(e){ return fb; } }
  function write(key, val){ try { localStorage.setItem(key, JSON.stringify(val)); } catch(e){} }

  /* =====================================================
     DEVICE COMPARISON
     ===================================================== */
  var COMPARE_KEY = 'scorpius_compare_v1';
  var COMPARE_MAX = 3;

  function getCompare(){ return read(COMPARE_KEY, []); }
  function setCompare(arr){ write(COMPARE_KEY, arr); renderCompareBar(); markCardButtons(); }

  function addCompare(item){
    var list = getCompare();
    if (list.some(function(p){ return p.handle === item.handle; })) {
      list = list.filter(function(p){ return p.handle !== item.handle; });
    } else {
      if (list.length >= COMPARE_MAX) { list.shift(); }
      list.push(item);
    }
    setCompare(list);
  }

  function removeCompare(handle){
    setCompare(getCompare().filter(function(p){ return p.handle !== handle; }));
  }

  function markCardButtons(){
    var handles = getCompare().map(function(p){ return p.handle; });
    $$('[data-compare-add]').forEach(function(btn){
      var on = handles.indexOf(btn.dataset.handle) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function renderCompareBar(){
    var bar = $('#compare-bar');
    if (!bar) return;
    var list = getCompare();
    var slots = $('#compare-bar-slots');
    if (!slots) return;
    if (list.length === 0) {
      bar.classList.remove('is-open');
      bar.setAttribute('aria-hidden', 'true');
      return;
    }
    var html = '';
    list.forEach(function(item){
      html += '<div class="compare-bar__slot">' +
        (item.img ? '<img src="' + item.img + '" alt="">' : '<div class="compare-bar__slot-empty"></div>') +
        '<div class="compare-bar__slot-text"><div class="compare-bar__slot-title">' + item.title + '</div>' +
        '<div class="compare-bar__slot-price">' + (item.price || '') + '</div></div>' +
        '<button type="button" class="compare-bar__remove" data-compare-remove="' + item.handle + '" aria-label="Remove">' +
        '<svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div>';
    });
    var empties = COMPARE_MAX - list.length;
    for (var i = 0; i < empties; i++){
      html += '<div class="compare-bar__slot compare-bar__slot--empty"><div class="compare-bar__slot-empty"></div><div class="compare-bar__slot-hint">Add a device</div></div>';
    }
    slots.innerHTML = html;
    bar.classList.add('is-open');
    bar.setAttribute('aria-hidden', 'false');
  }

  function renderComparisonPage(){
    var root = $('#comparison-grid');
    var empty = $('#comparison-empty');
    if (!root || !empty) return;
    var list = getCompare();
    if (list.length === 0) {
      empty.style.display = '';
      root.style.display = 'none';
      return;
    }
    empty.style.display = 'none';
    root.style.display = '';
    // Fetch full product details to show specs
    Promise.all(list.map(function(p){
      return fetch('/products/' + p.handle + '.js').then(function(r){ return r.json(); }).catch(function(){ return null; });
    })).then(function(products){
      var cells = products.filter(Boolean);
      if (cells.length === 0) { root.innerHTML = '<p>Could not load product data.</p>'; return; }

      var headerHtml = '<div class="cmp-row cmp-row--head"><div class="cmp-cell cmp-cell--label"></div>';
      cells.forEach(function(p){
        headerHtml += '<div class="cmp-cell cmp-cell--head">' +
          (p.featured_image ? '<img src="' + p.featured_image + '" alt="">' : '') +
          '<div class="cmp-cell__title">' + p.title + '</div>' +
          '<div class="cmp-cell__price">' + money(p.price) + '</div>' +
          '<a href="/products/' + p.handle + '" class="btn btn--ink btn--full" style="margin-top:10px">View product</a>' +
          '<button type="button" class="cmp-remove" data-compare-remove="' + p.handle + '">Remove</button>' +
          '</div>';
      });
      headerHtml += '</div>';

      function row(label, getter){
        var h = '<div class="cmp-row"><div class="cmp-cell cmp-cell--label">' + label + '</div>';
        cells.forEach(function(p){
          h += '<div class="cmp-cell">' + (getter(p) || '<span style="color:var(--silver)">—</span>') + '</div>';
        });
        h += '</div>';
        return h;
      }

      var rows = '';
      rows += row('Brand / vendor', function(p){ return p.vendor; });
      rows += row('Type', function(p){ return p.type; });
      rows += row('Available', function(p){ return p.available ? '<span style="color:var(--green-d);font-weight:700">In stock</span>' : 'Sold out'; });
      rows += row('Variants', function(p){ return (p.variants || []).map(function(v){ return v.title + ' — ' + money(v.price); }).join('<br>'); });
      rows += row('Tags', function(p){
        return (p.tags || []).map(function(t){ return '<span class="cmp-tag">' + t + '</span>'; }).join(' ');
      });
      rows += row('Compare at price', function(p){
        return p.compare_at_price && p.compare_at_price > p.price ? money(p.compare_at_price) : '';
      });

      root.innerHTML = headerHtml + rows;
      root.style.gridTemplateColumns = '160px repeat(' + cells.length + ', 1fr)';
    });
  }

  function bindCompareGlobal(){
    document.addEventListener('click', function(e){
      var add = e.target.closest('[data-compare-add]');
      if (add) {
        e.preventDefault();
        addCompare({
          handle: add.dataset.handle,
          title: add.dataset.title,
          vendor: add.dataset.vendor,
          price: add.dataset.price,
          img: add.dataset.img,
          url: add.dataset.url
        });
        return;
      }
      var rm = e.target.closest('[data-compare-remove]');
      if (rm) {
        e.preventDefault();
        removeCompare(rm.dataset.compareRemove);
        renderComparisonPage();
        return;
      }
    });
    var clr = $('#compare-clear');
    if (clr) clr.addEventListener('click', function(){ setCompare([]); });
  }

  /* =====================================================
     QUICK VIEW MODAL
     ===================================================== */
  function openQuickview(handle){
    var modal = $('#quickview');
    var body = $('#quickview-body');
    if (!modal || !body) return;
    body.innerHTML = '<div class="quickview__loader">Loading…</div>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.json(); })
      .then(function(p){
        var imgs = (p.images && p.images.length ? p.images : [p.featured_image]).filter(Boolean);
        var html = '<div class="quickview__media">' +
          (imgs[0] ? '<img src="' + imgs[0] + '" alt="" id="qv-main-img">' : '') +
          (imgs.length > 1 ? '<div class="quickview__thumbs">' + imgs.slice(0, 4).map(function(src, i){
            return '<button type="button" class="quickview__thumb' + (i === 0 ? ' active' : '') + '" data-src="' + src + '"><img src="' + src + '" alt=""></button>';
          }).join('') + '</div>' : '') +
          '</div>';
        html += '<div class="quickview__info">';
        if (p.vendor) html += '<div class="quickview__vendor">' + p.vendor + '</div>';
        html += '<h2 class="quickview__title">' + p.title + '</h2>';
        html += '<div class="quickview__price">' + money(p.price);
        if (p.compare_at_price && p.compare_at_price > p.price) {
          html += ' <s class="quickview__rrp">' + money(p.compare_at_price) + '</s>';
        }
        html += '</div>';
        if (p.description) {
          var desc = p.description.length > 240 ? p.description.slice(0, 240) + '…' : p.description;
          html += '<div class="quickview__desc">' + desc + '</div>';
        }
        html += '<form class="quickview__form" data-quickview-form><select name="id" class="quickview__variant"' + (p.variants.length < 2 ? ' style="display:none"' : '') + '>';
        p.variants.forEach(function(v){
          html += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + v.title + ' — ' + money(v.price) + (v.available ? '' : ' (sold out)') + '</option>';
        });
        html += '</select>';
        html += '<button type="submit" class="btn btn--ink btn--lg btn--full" style="margin-top:14px"' + (p.available ? '' : ' disabled') + '>' + (p.available ? 'Add to cart' : 'Sold out') + '</button>';
        html += '<a href="/products/' + p.handle + '" class="btn btn--outline btn--full" style="margin-top:10px">View full details</a>';
        html += '</form></div>';
        body.innerHTML = html;

        // Thumb switching
        $$('.quickview__thumb').forEach(function(t){
          t.addEventListener('click', function(){
            var src = this.dataset.src;
            var main = $('#qv-main-img');
            if (main && src) main.src = src;
            $$('.quickview__thumb').forEach(function(x){ x.classList.remove('active'); });
            this.classList.add('active');
          });
        });

        // AJAX add to cart
        var form = $('[data-quickview-form]');
        if (form) form.addEventListener('submit', function(e){
          e.preventDefault();
          var id = form.querySelector('[name="id"]').value;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, quantity: 1 })
          }).then(function(r){ return r.json(); }).then(function(){
            closeQuickview();
            // Trigger cart drawer if available
            var trig = document.getElementById('cart-trigger');
            if (trig) trig.click();
            // Bump cart count badge
            fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
              $$('.cart-count-badge').forEach(function(b){
                b.textContent = c.item_count;
                b.style.display = c.item_count ? '' : 'none';
              });
              updateShipBar(c);
              updateCartSustain(c);
            });
          });
        });
      })
      .catch(function(){
        body.innerHTML = '<div style="padding:60px;text-align:center"><p>Could not load product details.</p></div>';
      });
  }

  function closeQuickview(){
    var modal = $('#quickview');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function bindQuickview(){
    document.addEventListener('click', function(e){
      var q = e.target.closest('[data-quickview]');
      if (q) {
        e.preventDefault();
        openQuickview(q.dataset.quickview);
        return;
      }
      if (e.target.closest('[data-quickview-close]')) {
        closeQuickview();
      }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeQuickview();
    });
  }

  /* =====================================================
     TRADE-IN WIDGET on PDPs
     ===================================================== */
  function initTradeinWidget(){
    var widget = $('.tradein-widget');
    if (!widget) return;
    var prices = window.BUY_BACK_PRICES;
    if (!prices) return;
    var model = $('#tradein-model');
    var grade = $('#tradein-grade');
    var result = $('#tradein-result');
    var orig = $('#tradein-orig');
    var valEl = $('#tradein-value');
    var net = $('#tradein-net');
    var label = $('#tradein-model-label');
    if (!model || !grade) return;

    if (model.options.length <= 1) {
      Object.keys(prices).forEach(function(m){
        var o = document.createElement('option');
        o.value = m; o.textContent = m;
        model.appendChild(o);
      });
    }

    var productPrice = parseFloat(widget.dataset.tradeinProductPrice || '0');

    function recalc(){
      var m = model.value;
      var g = grade.value;
      if (!m || !g) { result.hidden = true; return; }
      var val = (prices[m] && prices[m][g]) || 0;
      var netVal = productPrice - val;
      if (label) label.textContent = m;
      if (valEl) valEl.textContent = '£' + val.toFixed(2);
      if (net) net.textContent = '£' + (netVal > 0 ? netVal.toFixed(2) : '0.00') + (netVal < 0 ? ' (we owe you £' + Math.abs(netVal).toFixed(2) + ')' : '');
      if (orig) orig.textContent = '£' + productPrice.toFixed(2);
      result.hidden = false;
    }

    model.addEventListener('change', recalc);
    grade.addEventListener('change', recalc);
  }

  /* =====================================================
     FREE SHIPPING PROGRESS BAR (in cart drawer)
     ===================================================== */
  function updateShipBar(cart){
    var bar = $('.ship-bar');
    if (!bar) return;
    var fill = $('#ship-bar-fill');
    var text = $('#ship-bar-text');
    var threshold = parseFloat(bar.dataset.threshold || '50') * 100;
    var total = (cart && cart.total_price != null) ? cart.total_price : 0;
    var pct = Math.min(100, (total / threshold) * 100);
    if (fill) fill.style.width = pct + '%';
    if (text) {
      if (total >= threshold) {
        text.innerHTML = '<strong>You\'ve unlocked free UK shipping</strong> &#127881;';
        bar.classList.add('is-unlocked');
      } else {
        var away = (threshold - total) / 100;
        text.innerHTML = 'You\'re <strong>£' + away.toFixed(2) + '</strong> away from free UK shipping';
        bar.classList.remove('is-unlocked');
      }
    }
  }

  /* =====================================================
     CART SUSTAINABILITY COUNTER
     ===================================================== */
  function updateCartSustain(cart){
    var slot = $('#sustain-cart-slot');
    if (!slot) return;
    if (!cart || cart.item_count === 0) { slot.innerHTML = ''; return; }
    var per = parseInt(slot.dataset.per || '70', 10);
    var total = cart.item_count * per;
    slot.innerHTML = '<div class="sustain-cart"><svg width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 2v20M2 12h20"/></svg><span>Your basket saves <strong>' + total + 'kg of CO&#8322;</strong> vs new.</span></div>';
  }

  function hookCartUpdates(){
    // Poll the cart once after any AJAX add elsewhere — scorpius.js already does its own thing,
    // so we listen for a custom event it can dispatch, plus we also pull on drawer open.
    var trigger = $('#cart-trigger');
    if (trigger) trigger.addEventListener('click', function(){
      setTimeout(function(){
        fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
          updateShipBar(c); updateCartSustain(c);
        });
      }, 250);
    });
    // Initial fetch
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      updateShipBar(c); updateCartSustain(c);
    }).catch(function(){});
  }

  /* =====================================================
     MOBILE COLLECTION SIDEBAR
     ===================================================== */
  function bindMobileSidebar(){
    var toggle = $('#shop-filter-toggle');
    var sidebar = $('#shop-sidebar');
    var overlay = $('#shop-sidebar-overlay');
    var close = $('#shop-sidebar-close');
    if (!toggle || !sidebar) return;
    function open(){ sidebar.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); }
    function shut(){ sidebar.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
    toggle.addEventListener('click', open);
    if (overlay) overlay.addEventListener('click', shut);
    if (close) close.addEventListener('click', shut);
  }

  /* =====================================================
     INIT
     ===================================================== */
  function init(){
    bindCompareGlobal();
    bindQuickview();
    renderCompareBar();
    markCardButtons();
    renderComparisonPage();
    initTradeinWidget();
    hookCartUpdates();
    bindMobileSidebar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
